import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { LitterLinksPage } from '@presentation/pages';
import type { LitterLinksItem } from '@presentation/pages';
import { PageSkeleton } from '@presentation/pages/LocationLinks/components/PageSkeleton';
import { useMemo } from 'react';
import { useSeo } from './useSeo';
import { useGetBreeds } from './api/useGetBreeds';
import { useFormatBreeds } from './api/useFormatBreeds';

export const LitterLinksPageController = () => {
  const { routeLocationDescriptor } = useRouter();

  const { breeds, breedsLoading } = useGetBreeds();
  const { breedOptionsBasenameKey } = useFormatBreeds(breeds);

  const { pageTitle, seoDescription, seoTitle } = useSeo();

  const items = useMemo((): LitterLinksItem[] => {
    return breedOptionsBasenameKey.map((item) => {
      const to = routeLocationDescriptor('litterList', { params: [encodeURI(item.value)] });
      return {
        label: item.label,
        to,
      } as LitterLinksItem;
    });
  }, [breedOptionsBasenameKey, routeLocationDescriptor]);

  return (
    <>
      <SeoController title={seoTitle} description={seoDescription} />
      {breedsLoading ? <PageSkeleton /> : <LitterLinksPage items={items} pageTitle={pageTitle} />}
    </>
  );
};
